/**
 * Lo que el pie del sidebar dice de la persona conectada.
 *
 * Dos strings, pero los dos que se ven en TODAS las pantallas: es el único
 * bloque de la interfaz que nunca se va. Unas iniciales vacías dejan un círculo
 * en blanco permanente, y eso no lo agarra ningún test de la pantalla que uno
 * esté mirando.
 */

/**
 * Las iniciales para el avatar: primera letra de las dos primeras palabras.
 *
 * **Filtra los espacios de más**, a diferencia de `imprenta`, que hace
 * `split(" ")` a secas: con un espacio doble la segunda «palabra» es `""`, su
 * `charAt(0)` también, y las iniciales salen con una sola letra sin que se
 * entienda por qué.
 */
export function iniciales(nombre: string): string {
  const letras = nombre
    .split(" ")
    .filter((parte) => parte.length > 0)
    .slice(0, 2)
    .map((parte) => parte.charAt(0))
    .join("")
    .toUpperCase();
  // «U» de usuario, como allá: es preferible a un círculo vacío.
  return letras || "U";
}

/**
 * Los roles de la persona, para la línea debajo del nombre.
 *
 * `imprenta` muestra UNO (`user.role.name`) porque allá el usuario tiene uno
 * solo. Acá puede tener varios (ADR 0015), y mostrar el primero escondería
 * autoridad que la persona sí tiene.
 */
export function textoDeRoles(roles: readonly string[]): string {
  return roles.length > 0 ? roles.join(", ") : "Sin rol asignado";
}
